import { ClientData } from './client';

export const RBF_PRODUCT_ID = '055fc406-c25e-4fa2-99be-ac31359f7e67';
export const TERMLOAN_PRODUCT_ID = '07f40272-7db7-4beb-910a-2299afccd5d9';

export type ApplicationStatusTypes =
  | 'NotSubmitted'
  | 'PendingSignatures'
  | 'InVerification'
  | 'OffersReceived'
  | 'DocumentsRequired'
  | 'OfferAccepted'
  | 'ContractsOut'
  | 'Closing'
  | 'ClearToClose'
  | 'Funded'
  | 'Rejected';

export const AllApplicationStatusTypes = [
  'NotSubmitted',
  'PendingSignatures',
  'InVerification',
  'OffersReceived',
  'DocumentsRequired',
  'OfferAccepted',
  'ContractsOut',
  'Closing',
  'ClearToClose',
  'Funded',
  'Rejected',
];

export type OwnerInfo = {
  clientId: string;
  id: string;
  appId?: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  emailAddress: string;
  dateOfBirth?: Date;
  SSN: string;
  percentOwnership: number;
  homeStreetAddress1: string;
  homeStreetAddress2: string;
  city: string;
  state: string;
  zip: string;
  createdAt: Date;
  updatedAt: Date;
  userDate?: string;
  isAuthorizedSigner?: boolean;
};

export type StipInfo = {
  fileName: string;
  type: string;
  result: string | ArrayBuffer;
  id: number;
  stipId: string;
};

export type Stips = {
  [index: string]: string | StipInfo[] | StipInfo | undefined;
  appId: string;
  bankStatements: StipInfo[];
  driverLicence?: StipInfo;
  voidedCheck?: StipInfo;
};

export type ApplicantInfo = {
  [index: string]: number | string | undefined | boolean | OwnerInfo[] | Date;
  clientId?: string;
  id?: string;
  appId?: string;
  legalBusinessName?: string;
  dba?: string;
  entityType: string;
  industry?: string;
  grossAnnualSales: number;
  requestedAmount: number;
  purposeOfCapital?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  emailAddress?: string;
  password?: string;
  businessStreetAddress1?: string;
  businessStreetAddress2?: string;
  businessCity?: string;
  businessState?: string;
  businessZip?: string;
  federalTaxID?: string;
  businessStartDate?: Date;
  businessPhone?: string;
  averageMonthlySales: number;
  websiteURL?: string;
  acceptsCreditCards: boolean;
  hasCurrentShortTermFinancing: boolean;
  createdAt: Date;
  updatedAt: Date;
  owners: OwnerInfo[];
  businessInfoEdited: boolean;
  basicInfoEdited: boolean;
  ownerInfoEdited: boolean;
  userDate?: string;
  codatID?: string;
  plaidProcessorToken?: string;
};

export type OfferInfo = {
  clientId: string;
  id?: string;
  appId: string;
  approvedAmount: number;
  factorRate: number;
  term?: string;
  offerDate?: Date;
  createdAt: Date;
  updatedAt: Date;
};

export type Application = {
  clientId: string;
  id?: string;
  appId: string;
  productId?: string;
  status: ApplicationStatusTypes;
  dealId?: string;
  dealStatus?: string;
  createdAt?: Date;
  updatedAt?: Date;
  submittedDate?: Date;
  applicant: ApplicantInfo;
  acceptedAgreements: boolean;
  acceptedEsignConcent: boolean;
  offers: OfferInfo[];
  stips?: Stips;
  client?: ClientData;
  isFms?: boolean;
  hasDoneOfac?: boolean;
  hasDoneBankVerification?: boolean;
  hasContractSigned?: boolean;
  hasContractGenerated?: boolean;
};

export type ReviewData = {
  dealId: number;
  funderId: number;
  paymentType: string; //aka: remittanceSchedule on Approval
  businessNameLegal: string;
  businessNameDba: string;
  isos: string;
  owners: string;
  testEmail?: string;
  selectedOfferIndex?: number;
};
